<!-- Toast Container -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
  @for (toast of toasts; track toast.id) {
    <div class="toast show" [ngClass]="getToastClass(toast.type)" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <i class="me-2" [ngClass]="getToastIcon(toast.type)"></i>
        <strong class="me-auto">{{ toast.title }}</strong>
        @if (toast.dismissible) {
          <button type="button" class="btn-close" (click)="onDismiss(toast.id)" aria-label="Close"></button>
        }
      </div>

      @if (toast.message) {
        <div class="toast-body">
          {{ toast.message }}
        </div>
      }
    </div>
  }
</div>
